/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Recovery_One_LinerInputs */

const en_exp_recovery_one_liner = /** @type {(inputs: Exp_Recovery_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How quickly your heart rate drops between work intervals.`)
};

const de_exp_recovery_one_liner = /** @type {(inputs: Exp_Recovery_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie schnell deine Herzfrequenz zwischen Arbeitsintervallen abfällt.`)
};

/**
* | output |
* | --- |
* | "How quickly your heart rate drops between work intervals." |
*
* @param {Exp_Recovery_One_LinerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_recovery_one_liner = /** @type {((inputs?: Exp_Recovery_One_LinerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Recovery_One_LinerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_recovery_one_liner(inputs)
	return de_exp_recovery_one_liner(inputs)
});